<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>返现详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="div_box">
            <div style="display: flex; align-items: center;">
                <div>总金额：<txt>{{ amountList.TotalEarnedAmount }}元</txt>
                </div>
                <div style="margin-left: 30px;">可提现金额：<txt>{{ amountList.WithdrawableAmount
                        }}元</txt>
                </div>
                <div style="margin-left: 30px;">已提现付金额：<txt>{{ amountList.WithdrawnAmount
                        }}元</txt>
                </div>
            </div>
            <div style="display: flex; align-items: center;margin-top: 20px;">
                <el-input style="width: 180px;" placeholder="请输入提现金额(元)" prefix-icon="el-icon-edit" size="small"
                    v-model="inputmoney" clearable></el-input>
                <div style="margin-left: 20px;"> <el-button type="primary" size="small"
                        @click.native="openDialog">确定</el-button></div>
            </div>
        </div>
        <div class="list" style="margin-top: 20px;">
            <el-table :data="rebateList" ref="rebateList" style="width: 100%" size="small" stripe
                :row-class-name="tableRowClassName">
                <el-table-column prop="transaction_id" label="交易id"></el-table-column>
                <el-table-column prop="amount" label="交易金额(元)"></el-table-column>
                <el-table-column prop="description" label="来源"></el-table-column>
                <el-table-column prop="transaction_time" label="交易时间"></el-table-column>
                <el-table-column prop="transaction_type" label="交易类型"></el-table-column>
            </el-table>
        </div>
        <div class="block" v-if="false">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.page" :page-sizes="[10, 20, 30, 40]" :page-size="pagination.per_page"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total_transactions">
            </el-pagination>
        </div>
        <el-dialog title="转账提示" :visible.sync="isShowDialog" width="30%" center>
            <div style="text-align: center;font-size: 25px;">本次转账金额是{{ inputmoney }}元, 是否确认转账?</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isShowDialog = false">取 消</el-button>
                <el-button type="danger" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            rebateList: [],
            total: 0,
            userInfo: {},
            dialogAddData: false,
            inputmoney: '',
            pagination: {
                per_page: 10,
                page: 1
            },
            amountList: {
                TotalEarnedAmount: 0,
                WithdrawableAmount: 0,
                WithdrawnAmount: 0
            },
            isShowDialog: false
        }
    },
    created() {
        this.getRebateListTrue()
        this.getRebateListFalse()
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
        getRebateListTrue() {
            this.$get(`/v1/admin/users-balance-stats?user_id=${this.$route.query.user_id}&is_payment_history=1`, {}).then((res) => {
                console.log(res, '返现详情true')
                if (res.data.status === 'success') {
                    let list = res.data.transactions
                    list.forEach(item => {
                        item.amount /= 100
                        if (item.transaction_type == 'withdraw') {
                            item.transaction_type = '提现'
                        } else if (item.transaction_type == 'deposit') {
                            item.transaction_type = '存入'
                        }
                    });
                    this.rebateList = list
                    this.pagination = res.data.pagination
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        getRebateListFalse() {
            this.$get(`/v1/admin/users-balance-stats?user_id=${this.$route.query.user_id}&is_payment_history=0`, {}).then((res) => {
                console.log(res, '返现详情false')
                if (res.data.status === 'success') {
                    console.log(res.data.TotalEarnedAmount / 100, '总获得金额')
                    console.log(res.data.WithdrawableAmount / 100, '可提现金额')
                    console.log(res.data.WithdrawnAmount / 100, '已提现金额')
                    this.amountList.TotalEarnedAmount = res.data.TotalEarnedAmount / 100
                    this.amountList.WithdrawableAmount = res.data.WithdrawableAmount / 100
                    this.amountList.WithdrawnAmount = res.data.WithdrawnAmount / 100
                    console.log(this.amountList, '===========')
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        handleSizeChange(val) {
            console.log(val)
            this.limit = val;
            this.getRebateListTrue()
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getRebateListTrue()
        },
        getOrderDetails(id) {
            this.getUserList(id)
        },
        openDialog() {
            const regex = /^(?:0|[1-9]\d*)(\.\d{1,2})?$/;
            if (this.inputmoney === '') {
                this.$message({
                    message: '输入内容不能为空哦',
                    type: 'warning'
                });
            } else if (regex.test(this.inputmoney)) {
                this.isShowDialog = true;
            } else {
                this.$message({
                    message: '请输入有效且非负的数字(整数部分可以为0,小数部分最多两位)',
                    type: 'error'
                });
            }
        },
        submit() {
            this.isShowDialog = false
            let inputmoney = +this.inputmoney
            inputmoney = inputmoney * 100
            console.log(inputmoney, '转账金额')
            this.postRebateListFalse(inputmoney)
        },
        postRebateListFalse(inputmoney) {
            let apiData = {
                amount: inputmoney,
                user_id: this.$route.query.user_id
            }
            this.$post(`/v1/admin/users-balance-stats`, apiData).then((res) => {
                console.log(res.data, '返现详情false')
                this.$msg(res.data.msg)
                this.getRebateListFalse()
                this.getRebateListTrue()
                this.inputmoney = ''
            });
        },
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.flex_box{
    margin: 12px;
    text-align right
}

.flex_box div {
    margin 10px
}

.right_box div {
    margin 10px
}
.right_box{
    color: red;
}

txt{
    color: red;
    font-weight 800
}

.div_box{
    margin-top 10px
}

.dialog_style{
    display flex
    align-items center
    justify-content center
    font-size 19px
    color #000
}

   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        input
          margin-right 20px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>


// WEBPACK FOOTER //
// src/pages/UserManage/userRebate.vue